// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Facebook Connection Component Styles */
/* Mirrors TikTokConnection.css with Facebook branding */

.facebook-connection {
    background: var(--card-bg, #fff);
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.facebook-connection.loading {
    display: flex;
    align-items: center;
    gap: 12px;
    justify-content: center;
    padding: 40px;
    color: var(--text-secondary, #666);
}

.facebook-connection .section-header {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 20px;
}

.facebook-connection .header-icon {
    font-size: 2.5rem;
    line-height: 1;
}

.facebook-connection .header-text h2 {
    margin: 0 0 8px 0;
    font-size: 1.5rem;
    color: var(--text-primary, #1a1a1a);
}

.facebook-connection .header-text .description {
    margin: 0;
    color: var(--text-secondary, #666);
    font-size: 0.95rem;
}

/* Alerts */
.facebook-connection .alert {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    border-radius: 8px;
    margin-bottom: 16px;
    font-size: 0.9rem;
}

.facebook-connection .alert-success {
    background: #f0fdf4;
    color: #166534;
    border: 1px solid #bbf7d0;
}

.facebook-connection .alert-error {
    background: #fef2f2;
    color: #991b1b;
    border: 1px solid #fecaca;
}

.facebook-connection .alert .dismiss {
    margin-left: auto;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1.2rem;
    color: inherit;
    opacity: 0.6;
}

.facebook-connection .alert .dismiss:hover {
    opacity: 1;
}

/* Connected Account */
.facebook-connection .account-card {
    border: 1px solid var(--border-color, #e5e7eb);
    border-radius: 10px;
    padding: 20px;
}

.facebook-connection .account-info {
    display: flex;
    align-items: flex-start;
    gap: 16px;
}

.facebook-connection .profile-picture {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
}

.facebook-connection .profile-picture.placeholder {
    background: linear-gradient(135deg, #4267B2, #898F9C);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
}

.facebook-connection .account-details {
    flex: 1 1;
}

.facebook-connection .account-details h3 {
    margin: 0 0 4px 0;
    font-size: 1.2rem;
    color: var(--text-primary, #1a1a1a);
}

.facebook-connection .page-category {
    display: inline-block;
    font-size: 0.8rem;
    color: #4267B2;
    background: #e7f0ff;
    padding: 2px 8px;
    border-radius: 10px;
    margin-bottom: 6px;
}

.facebook-connection .stats {
    display: flex;
    gap: 16px;
    margin: 8px 0;
    flex-wrap: wrap;
}

.facebook-connection .stat {
    font-size: 0.85rem;
    color: var(--text-secondary, #666);
}

.facebook-connection .stat strong {
    color: var(--text-primary, #1a1a1a);
}

.facebook-connection .connected-date,
.facebook-connection .last-post {
    margin: 4px 0 0;
    font-size: 0.8rem;
    color: var(--text-tertiary, #999);
}

.facebook-connection .status-badge {
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 600;
    flex-shrink: 0;
}

.facebook-connection .status-badge.active {
    background: #dcfce7;
    color: #166534;
}

.facebook-connection .status-badge.inactive {
    background: #fef3c7;
    color: #92400e;
}

/* Messenger Toggle */
.facebook-connection .messenger-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-top: 16px;
    padding: 14px 16px;
    background: #f8f9fa;
    border-radius: 10px;
    border: 1px solid var(--border-color, #e5e7eb);
}

.facebook-connection .messenger-info {
    display: flex;
    align-items: center;
    gap: 10px;
}

.facebook-connection .messenger-icon {
    font-size: 1.5rem;
}

.facebook-connection .messenger-info strong {
    display: block;
    font-size: 0.9rem;
    color: var(--text-primary, #1a1a1a);
}

.facebook-connection .messenger-description {
    margin: 2px 0 0;
    font-size: 0.8rem;
    color: var(--text-secondary, #666);
}

.facebook-connection .toggle-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
}

.facebook-connection .toggle-track {
    position: relative;
    width: 44px;
    height: 24px;
    background: #d1d5db;
    border-radius: 12px;
    transition: background 0.2s;
}

.facebook-connection .toggle-btn.enabled .toggle-track {
    background: #4267B2;
}

.facebook-connection .toggle-thumb {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 20px;
    height: 20px;
    background: #fff;
    border-radius: 50%;
    transition: transform 0.2s;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.facebook-connection .toggle-btn.enabled .toggle-thumb {
    transform: translateX(20px);
}

.facebook-connection .toggle-label {
    font-size: 0.8rem;
    font-weight: 600;
    color: var(--text-secondary, #666);
    min-width: 60px;
}

.facebook-connection .toggle-btn.enabled .toggle-label {
    color: #4267B2;
}

/* Token Warning */
.facebook-connection .token-warning {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 12px;
    padding: 10px 14px;
    background: #fef3c7;
    border-radius: 8px;
    color: #92400e;
    font-size: 0.85rem;
}

.facebook-connection .account-actions {
    display: flex;
    gap: 12px;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid var(--border-color, #e5e7eb);
}

/* No Account / Connect Prompt */
.facebook-connection .no-account {
    text-align: center;
    padding: 20px 0;
}

.facebook-connection .connect-prompt {
    margin-bottom: 24px;
}

.facebook-connection .connect-prompt .icon {
    font-size: 3rem;
    margin-bottom: 12px;
}

.facebook-connection .connect-prompt h3 {
    margin: 0 0 8px;
    font-size: 1.1rem;
    color: var(--text-primary, #1a1a1a);
}

.facebook-connection .connect-prompt p {
    margin: 0 0 16px;
    color: var(--text-secondary, #666);
    font-size: 0.9rem;
}

.facebook-connection .requirements {
    text-align: left;
    max-width: 400px;
    margin: 0 auto;
    padding-left: 20px;
    color: var(--text-secondary, #666);
    font-size: 0.85rem;
}

.facebook-connection .requirements li {
    margin-bottom: 6px;
}

/* Facebook branded connect button */
.facebook-connect-btn {
    background: #4267B2 !important;
    color: #fff !important;
    border: none !important;
    font-weight: 600;
}

.facebook-connect-btn:hover:not(:disabled) {
    background: #365899 !important;
}

/* Responsive */
@media (max-width: 768px) {
    .facebook-connection .account-info {
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .facebook-connection .stats {
        justify-content: center;
    }

    .facebook-connection .account-actions {
        flex-direction: column;
    }

    .facebook-connection .messenger-toggle {
        flex-direction: column;
        text-align: center;
    }

    .facebook-connection .messenger-info {
        flex-direction: column;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/FacebookConnection.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC,wDAAwD;;AAExD;IACI,gCAAgC;IAChC,mBAAmB;IACnB,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,SAAS;IACT,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA,sBAAsB;AACtB;IACI,8CAA8C;IAC9C,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,qDAAqD;IACrD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,kDAAkD;AACtD;;AAEA,gCAAgC;AAChC;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,oCAAoC;AACpC;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA,eAAe;AACf;IACI;QACI,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":["/* Facebook Connection Component Styles */\n/* Mirrors TikTokConnection.css with Facebook branding */\n\n.facebook-connection {\n    background: var(--card-bg, #fff);\n    border-radius: 12px;\n    padding: 24px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.facebook-connection.loading {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    justify-content: center;\n    padding: 40px;\n    color: var(--text-secondary, #666);\n}\n\n.facebook-connection .section-header {\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n    margin-bottom: 20px;\n}\n\n.facebook-connection .header-icon {\n    font-size: 2.5rem;\n    line-height: 1;\n}\n\n.facebook-connection .header-text h2 {\n    margin: 0 0 8px 0;\n    font-size: 1.5rem;\n    color: var(--text-primary, #1a1a1a);\n}\n\n.facebook-connection .header-text .description {\n    margin: 0;\n    color: var(--text-secondary, #666);\n    font-size: 0.95rem;\n}\n\n/* Alerts */\n.facebook-connection .alert {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 12px 16px;\n    border-radius: 8px;\n    margin-bottom: 16px;\n    font-size: 0.9rem;\n}\n\n.facebook-connection .alert-success {\n    background: #f0fdf4;\n    color: #166534;\n    border: 1px solid #bbf7d0;\n}\n\n.facebook-connection .alert-error {\n    background: #fef2f2;\n    color: #991b1b;\n    border: 1px solid #fecaca;\n}\n\n.facebook-connection .alert .dismiss {\n    margin-left: auto;\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 1.2rem;\n    color: inherit;\n    opacity: 0.6;\n}\n\n.facebook-connection .alert .dismiss:hover {\n    opacity: 1;\n}\n\n/* Connected Account */\n.facebook-connection .account-card {\n    border: 1px solid var(--border-color, #e5e7eb);\n    border-radius: 10px;\n    padding: 20px;\n}\n\n.facebook-connection .account-info {\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n}\n\n.facebook-connection .profile-picture {\n    width: 64px;\n    height: 64px;\n    border-radius: 50%;\n    object-fit: cover;\n    flex-shrink: 0;\n}\n\n.facebook-connection .profile-picture.placeholder {\n    background: linear-gradient(135deg, #4267B2, #898F9C);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.5rem;\n}\n\n.facebook-connection .account-details {\n    flex: 1;\n}\n\n.facebook-connection .account-details h3 {\n    margin: 0 0 4px 0;\n    font-size: 1.2rem;\n    color: var(--text-primary, #1a1a1a);\n}\n\n.facebook-connection .page-category {\n    display: inline-block;\n    font-size: 0.8rem;\n    color: #4267B2;\n    background: #e7f0ff;\n    padding: 2px 8px;\n    border-radius: 10px;\n    margin-bottom: 6px;\n}\n\n.facebook-connection .stats {\n    display: flex;\n    gap: 16px;\n    margin: 8px 0;\n    flex-wrap: wrap;\n}\n\n.facebook-connection .stat {\n    font-size: 0.85rem;\n    color: var(--text-secondary, #666);\n}\n\n.facebook-connection .stat strong {\n    color: var(--text-primary, #1a1a1a);\n}\n\n.facebook-connection .connected-date,\n.facebook-connection .last-post {\n    margin: 4px 0 0;\n    font-size: 0.8rem;\n    color: var(--text-tertiary, #999);\n}\n\n.facebook-connection .status-badge {\n    padding: 4px 12px;\n    border-radius: 20px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    flex-shrink: 0;\n}\n\n.facebook-connection .status-badge.active {\n    background: #dcfce7;\n    color: #166534;\n}\n\n.facebook-connection .status-badge.inactive {\n    background: #fef3c7;\n    color: #92400e;\n}\n\n/* Messenger Toggle */\n.facebook-connection .messenger-toggle {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    margin-top: 16px;\n    padding: 14px 16px;\n    background: #f8f9fa;\n    border-radius: 10px;\n    border: 1px solid var(--border-color, #e5e7eb);\n}\n\n.facebook-connection .messenger-info {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.facebook-connection .messenger-icon {\n    font-size: 1.5rem;\n}\n\n.facebook-connection .messenger-info strong {\n    display: block;\n    font-size: 0.9rem;\n    color: var(--text-primary, #1a1a1a);\n}\n\n.facebook-connection .messenger-description {\n    margin: 2px 0 0;\n    font-size: 0.8rem;\n    color: var(--text-secondary, #666);\n}\n\n.facebook-connection .toggle-btn {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 4px;\n}\n\n.facebook-connection .toggle-track {\n    position: relative;\n    width: 44px;\n    height: 24px;\n    background: #d1d5db;\n    border-radius: 12px;\n    transition: background 0.2s;\n}\n\n.facebook-connection .toggle-btn.enabled .toggle-track {\n    background: #4267B2;\n}\n\n.facebook-connection .toggle-thumb {\n    position: absolute;\n    top: 2px;\n    left: 2px;\n    width: 20px;\n    height: 20px;\n    background: #fff;\n    border-radius: 50%;\n    transition: transform 0.2s;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.facebook-connection .toggle-btn.enabled .toggle-thumb {\n    transform: translateX(20px);\n}\n\n.facebook-connection .toggle-label {\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: var(--text-secondary, #666);\n    min-width: 60px;\n}\n\n.facebook-connection .toggle-btn.enabled .toggle-label {\n    color: #4267B2;\n}\n\n/* Token Warning */\n.facebook-connection .token-warning {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-top: 12px;\n    padding: 10px 14px;\n    background: #fef3c7;\n    border-radius: 8px;\n    color: #92400e;\n    font-size: 0.85rem;\n}\n\n.facebook-connection .account-actions {\n    display: flex;\n    gap: 12px;\n    margin-top: 16px;\n    padding-top: 16px;\n    border-top: 1px solid var(--border-color, #e5e7eb);\n}\n\n/* No Account / Connect Prompt */\n.facebook-connection .no-account {\n    text-align: center;\n    padding: 20px 0;\n}\n\n.facebook-connection .connect-prompt {\n    margin-bottom: 24px;\n}\n\n.facebook-connection .connect-prompt .icon {\n    font-size: 3rem;\n    margin-bottom: 12px;\n}\n\n.facebook-connection .connect-prompt h3 {\n    margin: 0 0 8px;\n    font-size: 1.1rem;\n    color: var(--text-primary, #1a1a1a);\n}\n\n.facebook-connection .connect-prompt p {\n    margin: 0 0 16px;\n    color: var(--text-secondary, #666);\n    font-size: 0.9rem;\n}\n\n.facebook-connection .requirements {\n    text-align: left;\n    max-width: 400px;\n    margin: 0 auto;\n    padding-left: 20px;\n    color: var(--text-secondary, #666);\n    font-size: 0.85rem;\n}\n\n.facebook-connection .requirements li {\n    margin-bottom: 6px;\n}\n\n/* Facebook branded connect button */\n.facebook-connect-btn {\n    background: #4267B2 !important;\n    color: #fff !important;\n    border: none !important;\n    font-weight: 600;\n}\n\n.facebook-connect-btn:hover:not(:disabled) {\n    background: #365899 !important;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .facebook-connection .account-info {\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n    }\n\n    .facebook-connection .stats {\n        justify-content: center;\n    }\n\n    .facebook-connection .account-actions {\n        flex-direction: column;\n    }\n\n    .facebook-connection .messenger-toggle {\n        flex-direction: column;\n        text-align: center;\n    }\n\n    .facebook-connection .messenger-info {\n        flex-direction: column;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
